import { Box, Divider, Typography } from "@material-ui/core";
import {
  getCancellationPolicyInfo,
  getCancellationPolicyInfoV2,
  Icon,
  IconName,
} from "halifax";
import React from "react";
import { CancellationPoliciesCardConnectorProps } from "./container";
import {
  CALIFORNIA_BILL_644_CANCELLATION_TEXT,
  CANCELLATION_HEADING,
  FREE_CANCELLATION,
  FREE_FLIGHT_CANCEL,
} from "./textConstants";
import "./styles.scss";
import {
  CancellationPolicyEnum,
  CancellationReason,
  HotelCancellationPolicyV2Enum,
} from "redmond";
import clsx from "clsx";
import { getConfigTenant, isVesperTenant } from "@capone/common";

interface ICancellationPoliciesCardProps
  extends CancellationPoliciesCardConnectorProps {}

export const CancellationPoliciesCard = (
  props: ICancellationPoliciesCardProps
) => {
  const {
    chosenProduct,
    isVoidWindowEligible,
    cancellationSummary,
    cancellationPolicyV2,
    cancellationSummaryV2,
  } = props;

  const effectiveCancellationSummary =
    cancellationSummary ?? cancellationSummaryV2;

  if (!isVoidWindowEligible && !chosenProduct && !cancellationPolicyV2) {
    return null;
  }

  const isVesper = isVesperTenant(getConfigTenant());

  const cancellationPolicyInfo = chosenProduct?.cancellationPolicy
    ? getCancellationPolicyInfo(chosenProduct.cancellationPolicy)
    : cancellationPolicyV2
      ? getCancellationPolicyInfoV2(cancellationPolicyV2)
      : null;

  const isRefundable = chosenProduct?.cancellationPolicy
    ? chosenProduct.cancellationPolicy.CancellationPolicy ===
      CancellationPolicyEnum.Refundable
    : cancellationPolicyV2?.CancellationPolicyV2 ===
      HotelCancellationPolicyV2Enum.FullyRefundable;

  const isNonRefundable = chosenProduct?.cancellationPolicy
    ? chosenProduct.cancellationPolicy.CancellationPolicy ===
      CancellationPolicyEnum.NonRefundable
    : cancellationPolicyV2?.CancellationPolicyV2 ===
      HotelCancellationPolicyV2Enum.NonRefundable;

  return (
    <Box className={clsx("cancellation-policies-card-root", { redesigned: isVesper })}>
      <Typography variant="h3" className="packages-book-section-heading">
        {CANCELLATION_HEADING}
      </Typography>

      {cancellationPolicyInfo && (
        <>
          <Divider />
          <Box className="hotel-cancellation-container">
            <Box className="icon-wrapper">
              <Icon name={IconName.HotelFunnelIcon} />
            </Box>
            <Box className="text-container">
              <Typography
                className={clsx("title", { green: isRefundable })}
              >
                {cancellationPolicyInfo.primaryText}
              </Typography>
              <Typography variant="body2">
                {isNonRefundable &&
                effectiveCancellationSummary?.reasons.includes(
                  CancellationReason.CaliforniaBill644
                )
                  ? CALIFORNIA_BILL_644_CANCELLATION_TEXT
                  : cancellationPolicyInfo.secondaryText}
              </Typography>
            </Box>
          </Box>
        </>
      )}
      {isVoidWindowEligible && (
        <>
          <Divider />
          <Box className="flight-free-cancellation-container">
            <Box className="icon-wrapper">
              <Icon name={IconName.FlightFunnelIcon} />
            </Box>
            <Box className="free-cancellation-texts">
              <Typography className="title green">
                {FREE_CANCELLATION}
              </Typography>
              <Typography variant="body2">{FREE_FLIGHT_CANCEL}</Typography>
            </Box>
          </Box>
        </>
      )}
    </Box>
  );
};
